import Sidebar from './Sidebar.view';

export default Sidebar;
